import { logger } from '@tuic/logger';
import { trackEvent, trackPageView } from '@tuic/tracking';

import { extractImmediateTelemetry } from './extract-immediate-telemetry';

/**
 * Fires all immediate telemetry instructions from a block
 *
 * Extracts and executes all telemetry with trigger: 'immediate' from the block
 * and its nested structures. Handles both page view and event instructions.
 *
 * @param block - Content block data from the API (can be any shape)
 *
 * @example
 * ```tsx
 * // In invoke-prism-action.ts
 * if (!result.success && result.error) {
 *   fireImmediateTelemetry(result.error);
 * }
 * ```
 */
export function fireImmediateTelemetry(block: any): void {
  try {
    const immediateInstructions = extractImmediateTelemetry(block);

    for (const instruction of immediateInstructions) {
      if (instruction.type === 'pageView') {
        trackPageView(instruction.data);
      } else if (instruction.type === 'event') {
        trackEvent({
          event_name: instruction.eventName,
          ...instruction.data,
        });
      }
    }
  } catch (error) {
    logger.error('Failed to fire immediate telemetry:', error);
  }
}
